const whitelabelConfig = {
	'default': {
        'brand': 'default',
        'scssVariables': './src/styles/whitelabel-variables/default',
        'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
	},
  'pflegegrad-beantragen': {
        'brand': 'pflegegrad-beantragen',
        'scssVariables': './src/styles/whitelabel-variables/pflegegrad-beantragen',
        'title': 'Die Notruflösungen der Johanniter',
	},
	'pflegemarkt': {
        'brand': 'pflegemarkt',
        'scssVariables': './src/styles/whitelabel-variables/pflegemarkt',
        'title': 'Die Notruflösungen von Pflegemarkt',
	},
	'harz-energie': {
        'brand': 'harz-energie',
        'scssVariables': './src/styles/whitelabel-variables/harz-energie',
        'title': 'Die Notruflösungen von Harz Energie',
	},
	'mitpflegeleben': {
        'brand': 'harz-energie',
        'scssVariables': './src/styles/whitelabel-variables/mitpflegeleben',
        'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
	},
	'stadtwerkeneuss': {
        'brand': 'stadtwerkeneuss',
        'scssVariables': './src/styles/whitelabel-variables/stadtwerkeneuss',
        'title': 'Die Notruflösungen der Johanniter',
	},
    'stadtwerkewertheim': {
        'brand': 'stadtwerkewertheim',
        'scssVariables': './src/styles/whitelabel-variables/stadtwerkewertheim',
        'title': 'Die Notruflösungen der Johanniter',
	},
    'swg': {
        'brand': 'swg',
        'scssVariables': './src/styles/whitelabel-variables/swg',
        'title': 'Die Notruflösungen der Johanniter',
	},
    'stadtwerkeheide': {
        'brand': 'stadtwerkeheide',
        'scssVariables': './src/styles/whitelabel-variables/stadtwerkeheide',
        'title': 'Die Notruflösungen der Johanniter',
	},
	'thuegaenergie': {
        'brand': 'thuegaenergie',
        'scssVariables': './src/styles/whitelabel-variables/thuegaenergie',
        'title': 'Die Notruflösungen der Johanniter',
	},
    'seniorenportal': {
        'brand': 'faz',
        'scssVariables': './src/styles/whitelabel-variables/seniorenportal',
        'title': 'Die Notruflösungen der Johanniter',
    },
    'aue-bad-schlema': {
        'brand': 'aue-bad-schlema',
        'scssVariables': './src/styles/whitelabel-variables/aue-bad-schlema',
        'title': 'Die Notruflösungen der Johanniter',
    },
    'bad-bramstedt': {
      'brand': 'bad-bramstedt',
      'scssVariables': './src/styles/whitelabel-variables/bad-bramstedt',
      'title': 'Die Notruflösungen der Johanniter',
    },
    'zwickauer-energieversorgung': {
      'brand': 'zwickauer-energieversorgung',
      'scssVariables': './src/styles/whitelabel-variables/zwickauer-energieversorgung',
      'title': 'Die Notruflösungen der Johanniter',
    },
    'hausnotruf-testen': {
      'brand': 'hausnotruf-testen',
      'scssVariables': './src/styles/whitelabel-variables/hausnotruf-testen',
      'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    },
    'swd': {
      'brand': 'swd',
      'scssVariables': './src/styles/whitelabel-variables/swd',
      'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    },
    'burda': {
      'brand': 'burda',
      'scssVariables': './src/styles/whitelabel-variables/burda',
      'title': 'Finden Sie den passenden Johanniter-Hausnotruf',
    }
}

module.exports = whitelabelConfig



// WEBPACK FOOTER //
// ./whitelabel.config.js